import { render } from "./TheCommissionItem.vue?vue&type=template&id=c52f55dc&scoped=true&ts=true"
import script from "./TheCommissionItem.vue?vue&type=script&lang=ts"
export * from "./TheCommissionItem.vue?vue&type=script&lang=ts"

import "./TheCommissionItem.vue?vue&type=style&index=0&id=c52f55dc&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c52f55dc"]])

export default __exports__